// extracted by mini-css-extract-plugin
module.exports = {"table":"Table_table__2ZS9X","center":"Table_center__nwsVp","right":"Table_right__3_xlJ","fill":"Table_fill__3MEWA","footerHeader":"Table_footerHeader__1y2lb"};